import { halftoneDefinition, type HalftoneParameters } from "../../core/effects/halftone";

type HalftoneControlsProps = {
  parameters: HalftoneParameters;
  onChange: (patch: Partial<HalftoneParameters>) => void;
  onReset: () => void;
};

export function HalftoneControls({ parameters, onChange, onReset }: HalftoneControlsProps) {
  return (
    <div className="effect-controls">
      <div className="effect-controls__head">
        <div>
          <div className="panel-label">Controls</div>
          <strong>{halftoneDefinition.name}</strong>
        </div>
        <button type="button" onClick={onReset}>Reset</button>
      </div>

      <label>
        <span>Cell size <b>{parameters.cellSize}px</b></span>
        <input type="range" min="4" max="32" step="1" value={parameters.cellSize} onChange={(event) => onChange({ cellSize: Number(event.target.value) })} />
      </label>
      <label>
        <span>Angle <b>{parameters.angle}°</b></span>
        <input type="range" min="0" max="180" step="1" value={parameters.angle} onChange={(event) => onChange({ angle: Number(event.target.value) })} />
      </label>
      <label>
        <span>Dot gain <b>{parameters.dotGain.toFixed(2)}</b></span>
        <input type="range" min="0.25" max="2" step="0.05" value={parameters.dotGain} onChange={(event) => onChange({ dotGain: Number(event.target.value) })} />
      </label>
      <label>
        <span>Threshold <b>{parameters.threshold.toFixed(2)}</b></span>
        <input type="range" min="-1" max="1" step="0.05" value={parameters.threshold} onChange={(event) => onChange({ threshold: Number(event.target.value) })} />
      </label>
      <label className="control-row control-row--toggle">
        <span>Invert</span>
        <input type="checkbox" checked={parameters.invert} onChange={(event) => onChange({ invert: event.target.checked })} />
      </label>
      <div className="control-row control-row--colors">
        <label><span>Ink</span><input type="color" value={parameters.foreground} onChange={(event) => onChange({ foreground: event.target.value })} /></label>
        <label><span>Paper</span><input type="color" value={parameters.background} onChange={(event) => onChange({ background: event.target.value })} /></label>
      </div>
    </div>
  );
}
